import { fetch } from '../utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _querySellPlans(
  {
    page, size, direction, sort, startAt, endAt,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/sell-plans`,
    method: 'get',
    params: {
      startAt,
      endAt,
      page,
      size,
      direction,
      sort,
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _querySellPlan(sellPlanId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/sell-plans/${sellPlanId}`,
    method: 'get',
  });
}

/**
 * 新增
 * @param  title
 * @param  subTitle
 * @param  coverPath
 * @param  description
 * @param  topImagePath
 * @param  sellStartAt
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addSellPlan(
  {
    title,
    subTitle,
    coverPath,
    description,
    topImagePath,
    sellStartAt,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/sell-plans`,
    method: 'post',
    data: {
      title,
      subTitle,
      coverPath,
      description,
      topImagePath,
      sellStartAt,
    },
  });
}

/**
 * 更新
 * @param sellPlanId
 * @param  title
 * @param  subTitle
 * @param  coverPath
 * @param  description
 * @param  topImagePath
 * @param  sellStartAt
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateSellPlan(sellPlanId, {
  title,
  subTitle,
  coverPath,
  description,
  topImagePath,
  sellStartAt,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/sell-plans/${sellPlanId}`,
    method: 'patch',
    data: {
      title,
      subTitle,
      coverPath,
      description,
      topImagePath,
      sellStartAt,
    },
  });
}

/**
 * 删除
 * @param sellPlanId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteSellPlan(sellPlanId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/sell-plans/${sellPlanId}`,
    method: 'delete',
  });
}

export default {};
